import { Container } from 'semantic-ui-react';

const BlockStyleWrapper = (Component) => ({ ...props }) => {
  // We rely on className full-width from pastanaga theme,
  // so we have to rename the class from the style wrapper
  // props.className = props?.className?.replace(
  //   'has--fullwidth--true',
  //   'full-width',
  // );
  return (
    <div className={props.className}>
      <Container>
        <Component {...props} />
      </Container>
    </div>
  );
};

export default BlockStyleWrapper;
